import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg width="100%" height="480" viewBox="0 0 100% 480" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.10" fill="#8E90A2">
            <rect x="0%" y="10px" width="60%" height="40px" rx="2" />
            <rect x="0%" y="80px" width="100%" height="60px" rx="2" />
            <rect x="0%" y="170px" width="65%" height="20px" rx="2" />
            <rect x="0%" y="220px" width="15%" height="20px" rx="2" />
            <rect x="33%" y="220px" width="20%" height="20px" rx="2" />
            <rect x="66%" y="220px" width="17%" height="20px" rx="2" />
            <rect x="0%" y="260px" width="30%" height="50px" rx="2" />
            <rect x="33%" y="260px" width="30%" height="50px" rx="2" />
            <rect x="66%" y="260px" width="30%" height="50px" rx="2" />
            <rect x="0%" y="330px" width="15%" height="20px" rx="2" />
            <rect x="0%" y="360px" width="40%" height="20px" rx="2" />
            <rect x="0%" y="420px" width="40%" height="50px" rx="2" />
            <rect x="60%" y="420px" width="100%" height="50px" rx="2" />
        </g>
    </svg>
);

const BankModalLoadingIndicator = ({ shouldAnnounce = true, ...rest }) => (
    <RootWrapper {...rest}>
        {shouldAnnounce && <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>}
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default BankModalLoadingIndicator;
